import * as React from 'react';

import Unlock16 from './Unlock16';

export const unlock16 = () => <Unlock16 />;

export default {
    title: 'Icon/Line/Unlock16',
    component: Unlock16,
    parameters: {
        notes: "`import Unlock16 from 'box-ui-elements/es/icon/line/Unlock16';`",
    },
};
